import { apiRequest } from './client'
import type { PublishResult } from '@/types/bundle'

interface PublishResponse {
  version: string
  published_at: string
  changed_files: string[]
}

// POST /gui/v1/publish (PRD 24) - `version` is intentionally never sent;
// Phase 1 operator flow is always "next patch", the backend's own default
// when the field is omitted (Frontend PRD 08's explicit scope note).
export async function publishDraft(releaseNote: string): Promise<PublishResult> {
  const response = await apiRequest<PublishResponse>('/gui/v1/publish', {
    method: 'POST',
    body: JSON.stringify({ release_note: releaseNote }),
  })
  return {
    version: response.version,
    publishedAt: response.published_at,
    changedFiles: response.changed_files,
  }
}
